import { Box, Button, FormControl, FormLabel, Textarea } from '@mui/joy';
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { post, Token } from '../../../../../Script/Session';

function EmpfehlungsStandeditor() {

    const [edit, setedit] = useState();
    useEffect(() => {
        const stored = localStorage.getItem("empfehlung_edit_data"); 
        if (stored) {
            try {
                const parsed = JSON.parse(stored);
                setdata(JSON.parse(parsed.response));
                setedit(parsed.edit);
                setempfehlung(JSON.parse(parsed.response).empfehlung); // Optional chaining
            } catch (e) {
                console.error("Error parsing localStorage data:", e);
            }
        }
    }, []);
    const [data, setdata] = useState();
    const [empfehlung, setempfehlung] = useState();
    const navigate = useNavigate();


    function save() {
        let body = {};
        body.token = Token.get();
        body.targetid = data.id;
        body.action = "editempfehlung";
        body.newempf = empfehlung;
        let response = post(body, "/tarife/tarifstand");
        if (response == "LOGOUT") {
            navigate("/");
            return;
        }
        if (response == "OK") {
            window.open('', '_self');
            window.close();
        }



    }

    // Safely handle undefined data using optional chaining and conditional rendering
    if (!data) {
        return (
            <Box sx={{ height: "100vh", p: 2 }}>
                <FormLabel>Daten werden geladen...</FormLabel>
            </Box>
        );
    }
    return (
        <Box sx={{ height: "100vh", p: 2 }}>
            <FormControl>
                <FormLabel>Empfehlung</FormLabel>
                <Textarea
                    sx={{ bgcolor: empfehlung !== data?.empfehlung ? "yellow" : "white" }}
                    minRows={15}
                    onChange={(e) => setempfehlung(e.target.value)}
                    value={empfehlung}
                    placeholder="Empfehlung..."
                    variant="outlined"
                />
            </FormControl>
            {
                empfehlung !== data?.empfehlung && (
                    <Button onClick={() => save()} sx={{ mt: 1 }}>
                        Speichern
                    </Button>
                )
            }
        </Box>
    );
}

export default EmpfehlungsStandeditor
